import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";
import { AuthContext } from "../context/AuthProvider";

export default function useUser() {
  const { token, setUser, signout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleError = () => {
    signout(() => navigate("/login"));
  };

  const getMe = async () => {
    if (!token) {
      return;
    }
    try {
      const response = await fetchWithInterceptor("/api/user/me", {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        }
      });
      if (response.ok) {
        const data = await response.json();
        setUser(data);
      } else {
        handleError();
      }
    } catch (error) {
      handleError();
    }
  };

  useEffect(() => {
    getMe();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}